module.exports = __webpack_public_path__ + "img/fr_failure_6.b032850d.png";